import { useHover } from '@sparemin/blockhead';
import React from 'react';

import Tooltip from 'components/Tooltip';
import { TranscriptionTimeRemaining } from 'containers/FreeTranscriptionBalance';

import { TranscriptionFormValue } from './TranscriptionFormContext';
import TranscriptionToggle from './TranscriptionToggle';
import { block } from './utils';

interface TranscriptionToggleWrapperProps {
  newBalanceMillis: number;
  onClickTrancriptionRemaining: (
    event: React.MouseEvent<Element, MouseEvent>,
  ) => void;
  onTogglePopover: (show: boolean) => void;
  showBalance: boolean;
  transcriptionEnabled: boolean;
}

const TranscriptionToggleWrapper: React.FunctionComponent<TranscriptionToggleWrapperProps> = props => {
  const {
    newBalanceMillis,
    onClickTrancriptionRemaining,
    onTogglePopover,
    showBalance,
    transcriptionEnabled,
  } = props;

  const { hoverProps, isHovered } = useHover({
    isDisabled: !transcriptionEnabled,
  });

  const [prevIsHovered, setPrevIsHovered] = React.useState(isHovered);

  if (prevIsHovered !== isHovered) {
    setPrevIsHovered(isHovered);

    if (isHovered) {
      onTogglePopover(true);
    }
  }

  const handleToggleChange = React.useCallback(
    (nextValue: TranscriptionFormValue): void => {
      onTogglePopover(nextValue.transcribe);
    },
    [onTogglePopover],
  );

  return (
    <Tooltip
      content={
        <div className={block('balance-tooltip-content')}>
          <TranscriptionTimeRemaining
            className={block('balance')}
            onClick={onClickTrancriptionRemaining}
            remainingMillis={newBalanceMillis}
          />
        </div>
      }
      placement="top"
      show={showBalance && newBalanceMillis < 0 ? undefined : false}
    >
      <div {...hoverProps} className={block('toggle-wrapper')}>
        <TranscriptionToggle
          icon={null}
          label="Captions"
          labelClassName={block('toggle-label')}
          onChangeListener={handleToggleChange}
        />
      </div>
    </Tooltip>
  );
};

export default TranscriptionToggleWrapper;
